import { render, staticRenderFns } from "./VecdynColumnDefs.vue?vue&type=template&id=4a3460d7&"
import script from "./VecdynColumnDefs.vue?vue&type=script&lang=js&"
export * from "./VecdynColumnDefs.vue?vue&type=script&lang=js&"
import style0 from "./VecdynColumnDefs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports